import services from "@/services";

export const getApiJson = async (http, options) =>
  services
    .getApiJson(http, options)
    .then((data) => [null, data])
    .catch((err) => [err, null]);
export const getApiClassList = async (http, options) =>
  services
    .getApiClassList(http, options)
    .then((data) => [null, data])
    .catch((err) => [err, null]);
export const getApiSortClassList = async (http, options) =>
  services
    .getApiSortClassList(http, options)
    .then((data) => [null, data])
    .catch((err) => [err, null]);
export const getApicppenumList = async (http, options) =>
  services
    .getApicppenumList(http, options)
    .then((data) => [null, data])
    .catch((err) => [err, null]);
export const getApicppenumDetailList = async (http, options) =>
  services
    .getApicppenumDetailList(http, options)
    .then((data) => [null, data])
    .catch((err) => [err, null]);
export const getApicppstructList = async (http, options) =>
  services
    .getApicppstructList(http, options)
    .then((data) => [null, data])
    .catch((err) => [err, null]);
export const getApicppstructDetailList = async (http, options) =>
  services
    .getApicppstructDetailList(http, options)
    .then((data) => [null, data])
    .catch((err) => [err, null]);
export const getApiglobalfuncList = async (http, options) =>
  services
    .getApiglobalfuncList(http, options)
    .then((data) => [null, data])
    .catch((err) => [err, null]);
export const getApiClassDetailList = async (http, options) =>
  services
    .getApiClassDetailList(http, options)
    .then((data) => [null, data])
    .catch((err) => [err, null]);
export const getApiTreeList = async (http, options) =>
  services
    .getApiTreeList(http, options)
    .then((data) => [null, data])
    .catch((err) => [err, null]);
export const search = async (http, options) =>
  services
    .search(http, options)
    .then((data) => [null, data])
    .catch((err) => [err, null]);
export const report = async (http, options) =>
  services
    .report(http, options)
    .then((data) => [null, data])
    .catch((err) => [err, null]);
export const getInWhiteList = async (http, options) =>
    services
        .getInWhiteList(http, options)
        .then((data) => [null, data])
        .catch((err) => [err, null]);
export const feedbackCreate = async (http, options) =>
    services
        .feedbackCreate(http, options)
        .then((data) => [null, data])
        .catch((err) => [err, null]);
